export default {
  dataIterator: {
    rowsPerPageText: '1ページあたりの件数：',
    rowsPerPageAll: 'すべて',
    pageText: '{0}-{1} 件目 / {2}件',
    noResultsText: '検索結果が見つかりません。',
    nextPage: '次のページ',
    prevPage: '前のページ'
  },
  dataTable: {
    rowsPerPageText: '1ページあたりの行数：'
  },
  noDataText: 'データはありません。',
  carousel: {
    prev: '前のビジュアル',
    next: '次のビジュアル'
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/src/locale/ja.ts
// module id = K8Yk
// module chunks = 53